import * as React from "react";
import type { SVGProps } from "react";
const SvgDownArrowSm = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M16.375 12.833 12 17m0 0-4.375-4.167M12 17V7"
    />
  </svg>
);
export default SvgDownArrowSm;
